(function () {
  if (window.tjmPressQuotes) return;
  window.tjmPressQuotes = true;

  function init(root) {
    if (!root || root.getAttribute('data-tjm-quotes-ready') === 'true') return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-tjm-quotes-slide]'));
    var prev = root.querySelector('[data-tjm-quotes-prev]');
    var next = root.querySelector('[data-tjm-quotes-next]');
    if (slides.length < 2 || !prev || !next) return;

    root.setAttribute('data-tjm-quotes-ready', 'true');

    var index = 0;
    slides.forEach(function (slide, i) {
      if (!slide.hidden) index = i;
    });

    function show(nextIndex) {
      var count = slides.length;
      index = ((nextIndex % count) + count) % count;
      slides.forEach(function (slide, i) {
        if (i === index) {
          slide.hidden = false;
          slide.removeAttribute('aria-hidden');
        } else {
          slide.hidden = true;
          slide.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function onPrev(event) {
      event.preventDefault();
      show(index - 1);
    }

    function onNext(event) {
      event.preventDefault();
      show(index + 1);
    }

    function onKeydown(event) {
      if (event.altKey || event.metaKey || event.ctrlKey) return;
      if (!root.contains(event.target)) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(index + 1);
      }
    }

    prev.addEventListener('click', onPrev);
    next.addEventListener('click', onNext);
    root.addEventListener('keydown', onKeydown);

    root._tjmQuotes = {
      show: show,
      destroy: function () {
        prev.removeEventListener('click', onPrev);
        next.removeEventListener('click', onNext);
        root.removeEventListener('keydown', onKeydown);
        root.removeAttribute('data-tjm-quotes-ready');
        root._tjmQuotes = null;
      },
    };
  }

  function boot(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('[data-tjm-quotes]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-tjm-quotes]');
    if (root && root._tjmQuotes) root._tjmQuotes.destroy();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest('[data-tjm-quotes-slide]');
    if (!slide) return;
    var root = slide.closest('[data-tjm-quotes]');
    if (!root || !root._tjmQuotes) return;
    root._tjmQuotes.show(Number(slide.getAttribute('data-index')));
  });
})();
